module.exports = __webpack_public_path__ + "static/media/commodities_02.e037b9fd.jpg";